import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Be3Repository} from '@app/@core/repositories/be3/be3-repository';
import {Observable, of} from 'rxjs';
import {UserNote} from '@app/models/v3/user-note';

@Injectable({
  providedIn: 'root'
})
export class UserNoteRepository extends Be3Repository<UserNote> {

  constructor(http: HttpClient) {
    super(http, 'user-note');
  }

  findByUserId(userId: string): Observable<UserNote[]> {
    return this.http.get<UserNote[]>(`${this.entityUrl}/${userId}/notes`, {params: {userId}});
  }
}


